import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    ArrowDownDecorative,
    BaseballForV1,
    BasketballForV1,
    FootballForV1,
    GolfForV1,
    logo,
    logoColor,
    LogoIconWhite,
    SkatesForV1,
    SoccerForV1,
    studentFlowHomeBanner,
    TennisForV1,
    TennisSport,
    WhiteBall,
} from "../../../constant/imagePath";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import Colors from "../../../stories/assets/Colors";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { SearchBar } from "../../../stories/SearchBar/SearchBar";
import { Footer } from "../../../stories/Footer/Footer";
import classes from "./HomePageV1.module.css";
import HomePageMobile from "./HomePageV1Mobile";
import Fonts from "../../../stories/assets/Fonts";
import { PlayCard } from "../../../stories/PlayCard/PlayCard";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import { ReactSVG } from "react-svg";

function HomePageDesktop() {
    const [searchData, setSearchData] = useState({
        searchArray: [
            "Tennis",
            "Soccer",
            "Football",
            "Golf",
            "Skating",
            "Baseball",
            "Basketball",
        ],
        locationArray: ["San Diego"],
        ShowShadow: true,
    });
    const [playcard, setPlaycard] = useState([
        {
            icon: TennisForV1,
            title: "Tennis",
            value: "1 283 coaches",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
        {
            icon: FootballForV1,
            title: "Football",
            value: "Comming soon",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
        {
            icon: GolfForV1,
            title: "Football",
            value: "Comming soon",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
        {
            icon: SoccerForV1,
            title: "Soccer",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
        {
            icon: BaseballForV1,
            title: "Baseball",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
        {
            icon: BasketballForV1,
            title: "Basketball",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
        {
            icon: SkatesForV1,
            title: "Basketball",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
            onClick: undefined,
        },
    ]);
    return (
        <div className={classes.homePage}>
            <section className={classes.heroSection}>
                <div className={classes.overlay}>
                    <Container fluid className={["p-0", classes.mainContainer].join(" ")}>
                        <AfterLoginHeader showSearch={false} icon={logo} isWhite />
                        <div className={[classes.heroContent].join(" ")}>
                            <h2
                                style={{
                                    ...Fonts.h2,
                                    fontSize: '54px',
                                    lineHeight: '68px',
                                    color: Colors.white,
                                    letterSpacing: "-0.5px",
                                }}
                            >
                                GET POWERFUL WORKOUTS WITH PROFESSIONAL COACHES
                            </h2>
                            <SearchBar
                                searchArray={searchData?.searchArray}
                                locationArray={searchData?.locationArray}
                                ShowShadow={searchData?.ShowShadow}

                            />
                            <div className={classes.lookHere}>
                                <ReactSVG src={WhiteBall} />
                                <p style={{ ...Fonts.p3, fontFamily: 'inter-500', color: Colors.white }}>Not sure what to choose? Look here</p>
                                <ReactSVG src={ArrowDownDecorative} />
                            </div>

                        </div>
                    </Container>
                </div>
            </section>
            <Container className={["p-0", classes.middleSection].join(" ")}>
                <div>
                    <div className={[classes.playCardMainDiv].join(" ")}>
                        {playcard?.map((item, i) => {
                            return (
                                <div className={[classes.playCardDiv].join(" ")}>
                                    <PlayCard
                                        icon={item.icon}
                                        title={item.title}
                                        value={item.value}
                                        iconStyle={{ width: '48px', height: '48px', margin: '0 auto' }}
                                        valueStyle={{ whiteSpace: 'nowrap', color: Colors.neutralShadesOfDimGray, ...Fonts.p2 }}
                                        titleStyle={{ ...Fonts.h6 }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Container>
            <Footer className={[classes.containerWidth].join(" ")} />
        </div>
    );
}

const HomePage = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        isMobileViewHook(setIsMobile, 992);
    }, []);

    return isMobile ? <HomePageMobile /> : <HomePageDesktop />;
};
export default HomePage;
